import { render, staticRenderFns } from "./Page002.vue?vue&type=template&id=09582b14&scoped=true&"
import script from "./Page002.vue?vue&type=script&lang=js&"
export * from "./Page002.vue?vue&type=script&lang=js&"
import style0 from "./Page002.vue?vue&type=style&index=0&id=09582b14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09582b14",
  null
  
)

export default component.exports